import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { REVIEW_SIZE } from 'screens/MortgageOfficePage/components/ReviewCard/styled';
import { CommonWrapper } from 'screens/MortgageOfficePage/styled';


export const Wrapper = styled.div`
  background: #FAF5F0;
  padding: ${({ theme }) => `${theme.spacing(8)} 0 ${theme.spacing(12)}`};
  overflow: hidden;
  position: relative;
  z-index: 1;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(4)} 0 ${theme.spacing(11)};
  `}
`;

export const ItemWrapper = styled.div`
  max-width: ${REVIEW_SIZE.width}px;
  width: 100%;
  position: relative;
  margin: 0 ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  line-height: 0;
`;

export const InfinityItemWrapper = styled(ItemWrapper)`
  margin: 0;
`;

export const CarouselWrapper = styled.div`
  position: relative;
  .arrows {
    display: none;
  }
  :hover .arrows {
    display: block;
  }
`;

const ArrowBase = styled.div`
  position: absolute;
  top: 0;
  bottom: -96px;
  width: 246px;
  user-select: none;
  cursor: pointer;
`;

export const ArrowLeftWrapper = styled(ArrowBase)`
  left: 0;
  background: linear-gradient(-90deg, rgba(236, 240, 255, 0.0001) 0%, #FAF5F0 84.65%);
  svg {
    left: 82px;
  }
`;

export const ArrowRightWrapper = styled(ArrowBase)`
  right: 0;
  background: linear-gradient(90deg, rgba(236, 240, 255, 0.0001) 0%, #FAF5F0 84.65%);
  svg {
    right: 82px;
  }
`;

export const ArrowCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 33%;
  transform: translateY(-50%);
  background: ${({ theme }) => theme.colors.neutrals.white};
`;

export const ArrowCircleLeft = styled(ArrowCircle)`
  left: 82px;
`;

export const ArrowCircleRight = styled(ArrowCircle)`
  right: 82px;
`;

export const TitleWrapper = styled(CommonWrapper)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(3)}};
  `}
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: ${typographyFontSizeCfg.h2.mobile}px;
  font-weight: bold;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    font-size: ${typographyFontSizeCfg.h3.mobile}px;
    line-height: ${typographyLineHeightCfg.h3.mobile}px;
  `}
`;

export const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;

export const StaticReviewWrapper = styled(CommonWrapper)<{ fullWidth?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  ${({ fullWidth }) => fullWidth ? `
    max-width: none;
    justify-content: center;
  ` : ''}
`;
